
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {pasteFromClipboard} from "@/plugins/clipboard";
  import {isIOS} from "mobile-device-detect";

  @Component({})
  export default class CarNumberInput extends Vue {
    @Prop() value: string;
    @Prop() disabled: boolean;

    $refs: any;
    publicPath: string = process.env.VUE_APP_PUBLIC_URL;
    firstLetter = '';
    threeNumbers = '';
    twoLetters = '';
    countryCode = '';
    keyCode = null;
    ctrlPress = false;
    inputs = {
      firstLetter: { length: 1, previous: null, next: 'threeNumbers', onlySymbols: true, },
      threeNumbers: { length: 3, previous: 'firstLetter', next: 'twoLetters', onlySymbols: false, },
      twoLetters: { length: 2, previous: 'threeNumbers', next: 'countryCode', onlySymbols: true, },
      countryCode: { length: 3, previous: 'twoLetters', next: null, onlySymbols: false, },
    };
    hexTokens = {
      L: {
        pattern: /[0-9a-zA-Zа-яА-Я]/,
      }
    };
    iosMessage = '';

    mounted() {
      this.prepareData();
    }

    prepareData() {
      this.firstLetter = this.value ? this.value.substr(0, 1) : '';
      this.threeNumbers = this.value ? this.value.substr(1, 3) : '';
      this.twoLetters = this.value ? this.value.substr(4, 2) : '';
      this.countryCode = this.value ? this.value.substr(6, 3) : '';
    }

    inputValue(event, prop) {
      this[prop] = event.target.value;
      let modelValue = this.firstLetter.toString() + this.threeNumbers.toString() + this.twoLetters.toString() + this.countryCode.toString();
      this.$emit('inputCarNumber', modelValue);
    }

    onKeyUp(event) {
      if (event.keyCode === 17 || event.which === 17) {
        this.ctrlPress = false;
      }
    }

    onKeyDown(event, prop) {
      // 37 - left, 39 - right, 8 - backspace, 46 - delete, 9 - tab, 17 - ctrl, 86 - V for ctrl+V
      this.keyCode = event.keyCode || event.which;

      const input: any = this.$refs[prop];
      let caretPosition = input.selectionStart ? input.selectionStart : 0;

      setTimeout(async () => {
        // Ctrl+V event.
        if (this.ctrlPress && this.keyCode === 86) {
          this.$refs[prop].blur();
          let value = await pasteFromClipboard();
          this.$emit('inputCarNumber', value);
          this.ctrlPress = false;
          setTimeout(() =>  this.prepareData(), 0);
          return;
        }

        else if (this.keyCode === 37) {
          if (this.$refs[prop].selectionStart === 0) {
            if (this.inputs[prop].previous) {
              this.$refs[this.inputs[prop].previous].focus();
              this.$nextTick(() => this.$refs[this.inputs[prop].previous].setSelectionRange(this.inputs[prop].length + 1, this.inputs[prop].length + 1));
            }
            return;
          }
        }

        else if (this.keyCode === 8) {
          if (this.$refs[prop].selectionStart === 0) {
            if (this.inputs[prop].previous) {
              this.$refs[this.inputs[prop].previous].focus();
            }
            return;
          }
          if (!isIOS) setTimeout(() =>  this.$refs[prop].setSelectionRange(caretPosition-1, caretPosition-1), 0);
        }

        else if (this.keyCode === 46) {
          setTimeout(() =>  this.$refs[prop].setSelectionRange(caretPosition, caretPosition), 0);
          return;
        }

        else if (this.keyCode === 39) {
          if (this.$refs[prop].selectionStart === this.inputs[prop].length && this.$refs[this.inputs[prop].next]) {
            if (this.inputs[prop].next) {
              this.$refs[this.inputs[prop].next].focus();
              this.$nextTick(() => this.$refs[this.inputs[prop].next].setSelectionRange(0, 0));
            }
            return;
          }

          if (this.$refs[prop].selectionStart !== this.inputs[prop].length && this.$refs[this.inputs[prop].next]) {
            this.$nextTick(() => this.$refs[this.inputs[prop].next].setSelectionRange(this.$refs[prop].selectionStar+1, this.$refs[prop].selectionStar+1));
            return;
          }
        }

        else if (this.keyCode === 9) {
          this.$emit('tabEvent');
          return;
        }

        else if (this.keyCode === 17) {
          this.ctrlPress = true;
          return;
        }

        else {
          if (this.$refs[prop].value && this.$refs[prop].value.length === this.inputs[prop].length && ![37, 8].includes(this.keyCode)) {
            let positionStep = isIOS ? 2 : 1;
            if (this.inputs[prop].next && caretPosition >= this.inputs[prop].length - positionStep) {
              this.iosMessage = `${caretPosition} --- ${this.$refs[prop].value} ---`;
              setTimeout(() => this.$refs[this.inputs[prop].next].focus(), 0);
              if (!isIOS) setTimeout(() => this.$refs[this.inputs[prop].next].setSelectionRange(0, 0), 0);
            }
            else {
              setTimeout(() => this.$refs[prop].setSelectionRange(caretPosition + 1, caretPosition + 1), 0);
            }
          }
        }
      }, 0);

      this.$emit('keydown', this.keyCode);
    }

    setFocus() {
      this.$refs.firstLetter.focus();
    }

    clickAction() {
      this.$emit('clickAction');
    }
  }
